import { PageTitle } from '@library/components/PageTitle';

export const LeaguesDashboard = () => {
  return (
    <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
      <PageTitle title="Leagues" />
    </div>
  );
};
